const queue = [];

const Mutex = {
    getLock() {
        // Crate two promises. Locking promise is meant to act like a lock itself, that can be passed to unlock
        // critical section. Waiting promise is used to block obtaining lock itself in case critical section was
        // already claimed.
        const lockingPromiseData = {};
        lockingPromiseData.promise = new Promise(resolve => lockingPromiseData.resolve = resolve);
        const waitingPromiseData = {};
        waitingPromiseData.promise = new Promise(resolve => waitingPromiseData.resolve = resolve);

        // This operation will happen when mutex will be unlocked.
        lockingPromiseData.promise.then(() => {
            // After unlocking critical section, remove first element from the queue.
            // The owner removes itself from the queue.
            queue.shift();

            // If there still 'someone' waiting in the queue return their promise to wait for another one.
            if (queue.length) {
                return queue[0].waitingPromiseData.resolve(queue[0].lockingPromiseData);
            }
        });

        if (queue.length === 0) {
            // Instantly resolve waiting promise so that the first comer can be let into critical section. Execution
            // thread will be granted access to 'mutex', which will allow it to yield critical section later on.
            waitingPromiseData.resolve(lockingPromiseData);
        }

        // Each queue entry is associated with one awaiting execution 'thread'. First element in the queue is always
        // the owner of the critical section.
        queue.push({ lockingPromiseData, waitingPromiseData });
        return waitingPromiseData.promise;
    },

    unlock(lockingPromiseData) {
        // Yield critical section to the next thread waiting in the queue.
        return lockingPromiseData.resolve();
    }
};


export {
    Mutex
};
